import React from 'react';
import SbEditable from 'storyblok-react';
import Buttons from '~/components/Dynamic/Buttons';
// import spanHeading from '~/utils/span-heading';

const TextCard = ({ blok }) => {
  if (!blok) return null;

  const HeadingTag = blok.tag && blok.tag.substr(0, 1) === 'h' ? blok.tag : 'h2';

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div
        className={`text-card ${blok.className || ''} ${
          blok.textAlign === 'center' && 'text-center justify-center align-center'
        }`}
      >
        {blok.icon?.filename && (
          <div className={`text-card__icon flex ${blok.textAlign === 'center' && 'justify-center'}`}>
            <img
              className={`${blok.iconClass || 'w-16'} select-none inline-block mb-6`}
              draggable={false}
              src={blok.icon.filename}
              alt={blok.icon.alt}
            />
          </div>
        )}
        <div>
          {blok.subHeading && (
            <div className="mb-3">
              <p
                className={`${blok.subHeadingClass || 'text-sh'} `}
                dangerouslySetInnerHTML={{ __html: blok.subHeading }}
              />
            </div>
          )}

          {blok.heading && (
            <HeadingTag
              className={`text-${HeadingTag} mb-3 ${blok.headingClass}`}
              purge-classname="text-h1 text-h2 text-h3 text-h4 text-h5"
              dangerouslySetInnerHTML={{
                __html: blok.heading,
              }}
            />
          )}

          {blok.content && (
            <div
              className={`prose ${blok.contentClass || ''} ${
                blok.textAlign === 'center' && 'text-center mx-auto justify-center align-center'
              }`}
              dangerouslySetInnerHTML={{ __html: blok.content }}
            />
          )}

          {blok.button?.length > 0 && (
            <Buttons blok={blok.button} className={`mt-10 ${blok.textAlign === 'center' && 'justify-center'} ${blok.buttonsClass}`} />
          )}
        </div>
      </div>
    </SbEditable>
  );
};

export default TextCard;
